export const Form = {
    nomeAbreviadoCs: "",
    numrCert: null,
    tipoCertidao: "",
    codgTipoCertidao: null,
    numrSeqCertidao: null,
    codgSituacaoCert: null,
    dataEntregaCert: "",
    dataEmissaoCert: "",
    dataQuitacaoCert: "",
    dataCompensCert: "",
    numrEmissaoCert: null,
    valrBruto: null,
    valrDesconto: null,
    valrLiquido: null,
    valrHonorAdvServ: null,
    numrCpfCs: null,
    numrMatriculaPessoalCs: null,
}

export const initFiltro = {
    flagQuitadoFolhaArh: "N",
    nomeAbreviadoCs: "",
    numrCert: "",
    numrCpfCs: "",
    numrMatriculaPessoalCs: "",
    dataEmissaoCert: "",
    dataQuitacaoCert: "",
    dataCompensCert: "",
    dataAutenticCert: "",
};

export const camposTabela = [
    { titulo: "Beneficiário", nome: "nomeAbreviadoCs" },
    { titulo: "CPF", nome: "numrCpfCs" },
    { titulo: "Matrícula", nome: "numrMatriculaPessoalCs" },
    { titulo: "Nº Certidão de Crédito", nome: "numrCert" },
    { titulo: "Tipo", nome: "tipoCertidao" },
    { titulo: "Data Emissão", nome: "dataEmissaoCert" },
    { titulo: "Data Quitação", nome: "dataQuitacaoCert" },
    { titulo: "Data Compensação", nome: "dataCompensCert" },
];

const url = "/certidoeslegadas";
const filtroCertidoesLegadas = '/validacertidaolegadas/filtrosvcl';
const id = "idenAmparoLegal"

export function pesquisarAll() {
    return new Promise((resolve, reject) => {
        window.$http.get(`${url}`).then((res) => {
            resolve(res.data);
        })
    })
}

export function buscatipocertidao() {
    return new Promise((resolve, reject) => {
        window.$http.get(`${url}/buscatipocertidao`).then((res) => {
            resolve(res.data);
        })
    })
}

export function buscaPersonalizada(paginacao, filtros) {
    return new Promise((resolve) => {
        window.$http.post(`${url}/buscapersonalizada?${paginacao}`, JSON.stringify(filtros)).then((res) => {
            resolve(res.data);
        })
    })
}

export function buscaCertidoesLegadas(filtros, paginacao) {

    return new Promise((resolve) => {
        window.$http.post(`${filtroCertidoesLegadas}?${paginacao}`, JSON.stringify(filtros)).then((res) => {
            resolve(res.data);
        })
    })
}

const urli = "/relatorios/pdfdecartdecredito";
export function imprimir(atributos) {
    return new Promise((resolve) => {
        window.$http.post(`${urli}`, JSON.stringify(atributos)).then((res) => {
            resolve(res.data);
        })
    })
}

const urlcertidoes = "/relatorios/pdfdecertidoeslegadas";
export function imprimirAll(atributos) {
    return new Promise((resolve) => {
        window.$http.post(`${urlcertidoes}`, JSON.stringify(atributos)).then((res) => {
            resolve(res.data);
        })
    })
}
const urlexportacao = "relatorios/exceldecertidoeslegadas";
export function exportarAll(atributos) {
    return new Promise((resolve) => {
        window.$http.post(`${urlexportacao}`, JSON.stringify(atributos)).then((res) => {
            resolve(res.data);
        })
    })
}




